import * as d3 from "d3";

export const fileUrlToCharge = (date, year, currentMode) => {
  let fileSolarLarge;
  let fileSolarSmall;
  let fileWind;
  let fileOffshore;
  if (currentMode === "realtime") {
    fileSolarLarge =
      "/data/realtime/installed_capacity_solar_large_" + date + ".csv";
    fileSolarSmall =
      "/data/realtime/installed_capacity_solar_small_" + date + ".csv";
    fileWind = "/data/realtime/installed_capacity_wind_" + date + ".csv";
    fileOffshore = "/data/realtime/installed_capacity_wind_offshore_" + date + ".csv";
  } else {
    fileSolarLarge =
      "/data/historical/installed_capacity_solar_large_" + year + ".csv";
    fileSolarSmall =
      "/data/historical/installed_capacity_solar_small_" + year + ".csv";
    fileWind = "/data/historical/installed_capacity_wind_" + year + ".csv";
    fileOffshore = "/data/historical/installed_capacity_wind_offshore_" + year + ".csv";
  }

  return { fileSolarLarge, fileSolarSmall, fileOffshore, fileWind };
};



 export const getFileOfCapacity =async (currentTech, date, year, currentMode) => {
  const files = fileUrlToCharge(date, year, currentMode);
  //const mapper = new Map();

 return await Promise.all([
    d3.csv(files.fileSolarLarge),
    d3.csv(files.fileSolarSmall),
    d3.csv(files.fileWind),
    d3.json("/map_data/wallonie_communes.json"),
    d3.csv(files.fileOffshore),
  ]).then(function (d, error) {
    
    const mapper = new Map();
    if (error) {
      console.log(error);
    } else {
      for (let i = 0; i < d[3].objects.RW_Communes.geometries.length; i++) {
        const ele = mapper.get(
          d[3].objects.RW_Communes.geometries[i].properties.ADPRKEY
        );
        let updatedValue = ele ? Number(ele) : 0;
        if (currentTech.solar) {
          updatedValue =
            updatedValue +
            Number(
              d[1][0][d[3].objects.RW_Communes.geometries[i].properties.ADMUKEY]
            ) +
            Number(
              d[0][0][d[3].objects.RW_Communes.geometries[i].properties.ADMUKEY]
            );
        }
        if (currentTech.wind) {
          updatedValue =
            updatedValue +
            Number(
              d[2][0][d[3].objects.RW_Communes.geometries[i].properties.ADMUKEY]
            );
        }
        if (currentTech.windOffshore) {
          mapper.set("windOffshore", Number(d[4][0][0]))
        }
        mapper.set(
          d[3].objects.RW_Communes.geometries[i].properties.ADPRKEY,
          updatedValue
        );
      }
     
    }
    return mapper
  });
};
